/**
 * Check if the menu should be responsive
 */
export const CHECK_RESPONSIVENESS = "CHECK_RESPONSIVENESS";
